import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface ListExtras {
	params?: NonNullable<Api.Operations['listExtras']['parameters']>['query']
	response: Api.Operations['listExtras']['responses']['200']['content']['application/json']
}

export const listExtras = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<ListExtras>(
		{
			method: 'get',
			url: '/extras',
			...overideConfig,
		},
		axiosInstance,
	)
